import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-remove",
  "use": "icon-remove-usage",
  "viewBox": "0 0 15 17",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 17\" id=\"icon-remove\"><path d=\"M2.808 16.884c-.499 0-.925-.176-1.278-.53A1.742 1.742 0 0 1 1 15.078V2.385H0v-1.5h4.5V0h6v.884H15v1.5h-1v12.693c0 .505-.175.932-.525 1.283-.35.35-.778.524-1.283.524H2.808Zm9.692-14.5h-10v12.693a.3.3 0 0 0 .087.221.3.3 0 0 0 .22.086h9.385a.294.294 0 0 0 .212-.096.294.294 0 0 0 .096-.211V2.385Zm-7.596 11h1.5v-9h-1.5v9Zm3.692 0h1.5v-9h-1.5v9Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol